export const FILE_STORAGE_PREFIX = "/app/storage/file/";
